export default {
  booking_confirmation_title: 'Potvrda rezervacije',
  booking_confirmation_body: 'Hvala vam na rezervaciji. Pojedinosti o potvrdi rezervacije nalaze se u nastavku.',
  location: 'Lokacija',
  pickup_location: 'Lokacija preuzimanja',
  dropoff_location: 'Lokacija povrata',
  vehicle: 'Vozilo',
  pickup_and_dropoff: 'Vrijeme preuzimanja i povrata (po lokalnom vremenu)',
  distance_allowance: 'Dozvoljena besplatna udaljenost',
  view_voucher: 'Prikaz vaučera',
  view_more_bookings: 'Prikaz više rezervacija',
  identity_verification_body: 'Prije preuzimanja vozila morat ćete potvrditi svoj identitet',
  identity_verification_title: 'Potvrdi identitet',
  search_again: 'Traži ponovno',
  aircon: 'aircon',
  not_available: 'Drive &amp; Go je trenutačno dostupan samo za osobe čiji su osobni dokumenti i vozačka dozvola iz {profiles}, ali stalno dodajemo nove zemlje.',
  check_if_included: 'Provjerite je li vaša zemlja uključena.',
  included_in_booking: 'Uključeno u ovu rezervaciju',
  cdw_with_excess: 'Osiguranje CDW uz isplatu',
  theft_protection: 'Zaštita od krađe uz isplatu',
  risk_reduction: 'Smanjenje rizika',
  free_extras: 'Uz ovu rezervaciju imate pravo na dva dodatka <br />.',
  total_cost: 'Ukupan trošak najma',
  continue: 'Nastavi',
  luggage_large_short_label: 'V',
  luggage_medium_short_label: 'S',
  luggage_small_short_label: 'M',
  luggage_large_long_label: 'veliko',
  luggage_medium_long_label: 'srednje',
  luggage_small_long_label: 'mali',
  fuel_unspecified_label: 'neodređeno',
  transmission_manual_label: 'Ručni',
  transmission_automatic_label: 'Automatski',
  make_a_booking: 'Izvrši rezervaciju',
  pickup_date: 'Datum preuzimanja',
  dropoff_date: 'Datum povrata',
  driver_age: 'Vozač između 30 i 65',
  enter_driver_age: 'Unesite dob vozača',
  promo_code: 'Promotivna šifra',
  search: 'Traži',
  dropoff_date_cannot_be_before_pickup_date: 'Datum povrata ne može biti prije datuma preuzimanja',
  pickup_date_cannot_be_in_the_past: 'Datum preuzimanja ne može biti u prošlosti',
  pickup_time_cannot_be_in_the_past: 'Vrijeme preuzimanja ne može biti u prošlosti',
  dropoff_time_must_be_later_than_the_pickup_time_if_on_the_same_day: 'Vrijeme povrata mora biti kasnije od vremena preuzimanja ako su oba isti dan',
  vehicle_filters: 'Filtri za biranje vozila',
  reset: 'Resetiraj',
  transmission: 'Transmisije',
  all: 'Svi',
  manual: 'Ručni',
  auto: 'Automatski',
  passengers: 'Putnici',
  vehicle_type: 'Tip vozila',
  filter: 'Filtar',
  vehicle_search: 'Traženje vozila',
  edit: 'Uredi',
  no_results: 'Nijedan rezultat ne odgovara vašim kriterijima odabira.',
  small_cars: 'Mali automobili',
  medium_cars: 'Srednje automobili',
  large_cars: 'Veliko automobili',
  estate_cars: 'Karavani',
  suvs: 'Sportski terenci (SUV)',
  mpvs: 'Višenamjenska vozila (MPV)',
  vans: 'Kombiji',
  camper_vans: 'Kamperi',
  premium: 'Luksuzna vozila',
  unspecified: 'neodređeno',
  large: 'veliko',
  medium: 'srednje',
  small: 'malo',
  automatic: 'automatski',
  you_have_been_refunded: 'Dobili ste povrat novca.',
  please_customer_service: 'Za rezervaciju kontaktirajte našu službu za korisnike.',
  contact_customer_service: 'kontaktirajte korisničku podršku',
  booking_failed: 'Trenutačno nije moguće obraditi vašu rezervaciju.',
  summary: 'Sažetak',
  reforestation_and_protection: 'Podržati pošumljavanje i zaštitu kišnih šuma diljem Kostarike',
  cost_of_rental: 'Cijena najma',
  to_pay_now: 'Plaćanje odmah',
  pay_on_arrival: 'Plaćanje na odredištu',
  greenheart_donation: 'Donacija za Green Heart',
  tc_agreement: 'Elolvastam és megértettem a (z) {0} -t.',
  tc: 'Felhasználási feltételek',
  receive_offers: 'Želim primati posebne ponude putem e-pošte.',
  donate: 'Da, želim donirati {amount}',
  pay_now: 'Plati {amount}',
  driver_details: 'Podaci o vozaču',
  complete_driver_details: 'Unesite podatke o vozaču.',
  are_you_the_driver: 'Jeste li vi vozač?',
  have_an_account: 'Imate li već račun?',
  login: 'Prijava',
  or: 'ili',
  first_name: 'Ime vozača',
  last_name: 'Prezime vozača',
  email: 'Adresa e-pošte',
  phone_number: 'Broj mobitela',
  unable_to_save_driver_information: 'Podaci o vozaču nisu spremljeni. Pokušajte ponovno.',
  pay_on_arrival: 'Plaćanje na odredištu',
  pay_online_now: 'Plaćanje odmah putem interneta',
  day: 'Dan',
  choose_location: 'Odaberite lokaciju.',
  pickup_location: 'Lokacija preuzimanja',
  dropoff_location: 'Lokacija povrata',
  location_not_found: 'Žao nam je, nismo mogli pronaći traženu lokaciju.',
  add: 'Dodaj',
  remove: 'Ukloni',
  free_extra: 'Besplatni dodaci',
  free: 'BESPLATNO!!',
  fast_track_notice: 'Za ovu uslugu vrijede ograničenja podrijetla dokumenata. Dostupna je samo osobama čiji su dokumenti iz',
  complete_booking: 'Završi rezervaciju',
  choose_card: 'Odaberite karticu ili dodajte novu.',
  add_billing_details: 'Dodajte podatke o naplati.',
  card_number: 'Broj kartice',
  card_holder_name: 'Ime vlasnika kartice',
  card_exp: 'MM / GG',
  card_cvc: 'CVC',
  save_card: 'Spremiti karticu?',
  amount_charged: 'Iznos će biti naplaćen putem vaše kartice',
  payment_confirmation: 'Potvrdi rezervaciju i plati',
  payment_methods: 'raspoloživi načini plaćanja',
  use_saved_card: 'x korištenje spremljene kartice',
  use_different_card: '+ korištenje druge kartice',
  book_now: 'Izvrši rezervaciju',
  minimum_age: 'Samo za osobe preko {age} godina',
  excess_liability: 'Povećano pokriće',
  security_deposit: 'Jamstveni polog',
  fuel_policy: 'Pravilo količine goriva',
  like_for_like: 'Koliko dobiješ toliko vraćaš',
  full_to_full: 'Dobiven i vraćen puni spremnik',
  miles_per_rental: '{mileage} besplatnih milja po najmu',
  km_per_rental: '{mileage} besplatnih kilometara po najmu',
  unlimited: 'Neograničeno',
  unlimited_mileage: 'Neograničeno milja',
  unlimited_mileage_km: 'Neograničeno kilometara',
  non_amendable: 'Neizmjenjivo',
  non_refundable: 'Bespovratno',
  free_cancellation_until: 'Besplatno odustajanje do',
  cancellation_in_line_with: 'Odustajanje u skladu s',
  tcs: 'Uvjetima i odredbama',
  free_extras_on_collection: 'Dva besplatna dodatka prilikom preuzimanja',
  glass_and_tyres_covered: 'Pokriće za stakla i gume',
  number_of_passengers: 'Broj putnika',
  number_of_bags: 'Broj torbi',
  fuel_type: 'Vrsta goriva',
  co2: 'CO2',
  aircon: 'Air Con',
  refrigeration: 'Hladnjak',
  book_type: 'Rezerviraj {type}',
  processing: 'U obradi...',
  actual_price: 'Stvarna cijena',
  tooltip: 'Cijena u $ {currencyCode} procijenjena je na temelju valutnog tečaja. Važeća je cijena u {currency}.',
  deposit: 'Uplati',
  pay_online: 'Plaćanje odmah putem interneta',
  pay_online_without_extras: 'Cijena najma',
  extras_on_arrival: 'Dodaci na odredištu',
  insurance_on_arrival: 'Smanjenje rizika - plaćanje na odredištu',
  insurance_online: 'Smanjenje rizika - plaćanje odmah',
  extras_online: 'Dodaci - plaćanje odmah',
  aircon_lower: 'aircon',
  why_use_drive_and_go: 'Zašto koristiti Drive & Go?',
  straight_to_car: 'Ravno do automobila',
  no_queues: 'Bez redova čekanja',
  self_checkout: 'Samopreuzimanje',
  cant_lose_key: 'Ključ se ne smije izgubiti',
  online_id_check: 'Internetska provjera ID-a',
  phone_as_key: 'Telefon kao ključ',
  premiumplus_benefits_includes: 'Uključene su i Premium Plus+ prednosti',
  book_drive_go: 'Rezerviraj Drive & Go',
  duration: 'Trajanje',
  to_pay_on_arrival: 'Plaćanje na odredištu',
  return_date: 'Datum povratka',
  my_profile: null,
  green_heart_donation: 'Donacija za Green Heart',
  drive_and_go: {
    drive_and_go: 'Drive And Go',
    available_countries: 'Drive &amp; Go je trenutačno dostupan samo za osobe čiji su osobni dokumenti i vozačka dozvola iz sljedećih zemalja:',
    drive_and_go_shortened: 'Drive & Go',
    why_use_drive_and_go: 'Zašto koristiti Drive & Go?',
    straight_to_car: 'Ravno do automobila',
    no_queues: 'Bez redova čekanja',
    self_checkout: 'Samopreuzimanje',
    cannot_lose_the_key: 'Ključ se ne smije izgubiti',
    online_id_check: 'Internetska provjera ID-a',
    phone_as_a_key: 'Telefon kao ključ',
    premium_plus_benefits_also_included: 'Uključene su i Premium Plus+ prednosti',
    book_drive_and_go: 'Rezerviraj Drive & Go',
    drive_and_go_today: 'Rezervacija Drive & Go dostupna je odmah!'
  },
  my_bookings: "My booking",
  no_bookings: "No booking",
  no_bookings_to_display: 'Nema rezervacija za prikaz.',
  search_great_car_rental_deals: "Search great car rental deals for your next trip.",
  odometer_at_collection: 'Broj kilometara na mjestu preuzimanja',
  fuel_at_collection: 'Količina goriva na mjestu preuzimanja',
  start_check_in: 'Počni s prijavom',
  start_collection: 'Počni preuzimanje',
  additional_options: 'Dodatne opcije',
  booking_details: 'Podaci o rezervaciji',
  price_for_x_days: 'Cijena za {qty_of_days} dan | Cijena za {qty_of_days} dana',
  cancelled: 'Otkazano',
  upcoming: 'Nadolazeće',
  active: 'Aktivno',
  recent_bookings: 'Nedavne rezervacije',
  damage: {
    updated_damage_report_submitted: 'Podnesena je ažurirana prijava štete. Ako je potrebno, kontaktirat će vas naša korisnička služba.',
    add_additional_damage: 'Dodavanje dodatne štete',
    you_may_report_additional_damage_up_to: 'Dodatnu štetu možete prijaviti do 24 sata nakon odjave vozila',
    specify_damage: 'Opišite oštećenje',
    please_choose_the_area_and_type_of_damage: 'Odaberite područje i vrstu oštećenja',
    type_of_damage: 'Vrsta oštećenja',
    is_this_more_than_5_cm: 'Je li to više od 5 cm?',
    please_take_or_select_a_photo: 'Snimite ili odaberite fotografiju',
    please_take_a_photo_ensuring_the_damage_is_clearly_visible: 'Snimite fotografiju, pripazite da se oštećenje jasno vidi',
    if_you_require_you_may_add_another_photo_select_the_icon_to_add_another_photo: ' Ako je potrebno, možete dodati još jednu fotografiju - odaberite ikonu za dodavanje još jedne fotografije',
    save_image: 'Spremi sliku',
    save_images: 'Spremi slike',
    damage_saved_successfully: 'Oštećenje uspješno spremljeno',
    add_photo: 'Dodaj fotografiju'
  },
  rental_agreement: {
    rental_agreement: 'Ugovor o najmu',
    agreement_between: 'Ugovor između',
    and: 'i',
    sign_rental_agreement: 'Potpiši ugovor o najmu',
    i_have_read_and_understood_the_terms_and_conditions: 'Elolvastam és megértettem a (z) Felhasználási feltételek -t, és elfogadtam a jármű állapotát'
  },
  checkin: {
    start_collection: 'Započni preuzimanje',
    collect_vehicle: 'Preuzimanje vozila',
    we_will_let_you_know_the_details: 'Javit ćemo vam lokaciju i podatke za preuzimanje unajmljenog vozila.',
    inspect: 'Provjera',
    we_will_ask_for_four_photos_from_each_corner: 'Zatražit ćemo od vas 4 fotografije - po jednu sa svakog ugla vozila, kao i slike oštećenja koja još nisu navedena.',
    fuel_and_milage: 'Gorivo i kilometraža',
    you_confirm_the_readings_at_the_start_of_your_hire: 'Očitanje odometra i količine goriva potvrđujete na početku najma.',
    sign: 'Potpis',
    sign_the_rental_agreement: 'Potpišite ugovor o najmu.',
    away_you_go: 'Vrijeme za pokret',
    you_are_free_to_take_to_the_road: 'Slobodno možete krenuti!',
    collect_your_vehicle: 'Preuzmi vozilo',
    get_directions: 'Prikaži upute o smjeru kretanja',
    hide_directions: 'Sakrij upute o smjeru kretanja',
    local_time: 'lokalno vrijeme',
    tel: 'Tel.',
    getting_to_the_location: 'Stizanje do lokacije',
    get_vehicle_details: 'Podaci o vozilu',
    view_map: 'Prikaži kartu',
    unlock_vehicle_and_continue: 'Otključaj vozilo i nastavi',
    unable_to_connect_to_vehicle: 'Povezivanje s vozilom nije uspjelo',
    we_were_unable_to_connect_to_the_vehicle_please_check: 'Nismo se mogli spojiti s vozilom - provjerite nalazite li se uz odgovarajuće vozilo i pokušajte ponovno.',
    we_were_unable_to_find_the_vehicle_booking_please_try_again_later: 'Nismo pronašli rezervaciju vozila. Molimo vas da pokušate ponovno kasnije.',
    odometer_and_fuel: 'Odometar i gorivo',
    odometer: 'Odometar (brojač kilometara)',
    please_confirm_the_odometer_and_fuel_readings: 'Potvrdite očitanje odometra i količine goriva.',
    the_odometer_field_is_required: 'Potrebno je ispuniti polje očitanja odometra',
    and_must_be_greater_than_the_checkout_odometer: 'Broj mora biti veći od očitanja prilikom preuzimanja',
    confirm: 'Potvrdi',
    please_take_a_photo_from_each_corner_of_the_vehicle: 'Molimo vas da snimite 4 fotografije - po jednu sa svakog ugla vozila',
    pre_existing_damage: 'Prethodna oštećenja',
    no_pre_existing_damage: 'Nema prethodnih oštećenja',
    new_damage: 'Novo oštećenje',
    add_additional_damage: 'dodaj nova oštećenja',
    no_new_damage_to_report: 'Nema novih oštećenja',
    checkout_complete: 'Preuzimanje je završeno',
    start_rental: 'Kreni s unajmljenim vozilom',
    congratulations_name_it_is_time_to_take_to_the_road: '{customer_name}, čestitamo - slobodno možete krenuti!',
    we_are_unable_to_complete_your_vehicle_checkout: 'Ne možemo dovršiti preuzimanje vašeg vozila.',
    please_do_the_following: 'Molimo vas da napravite sljedeće:',
    remove_all_belonging_and_lock_the_vehicle: 'Uzmite sve svoje stvari i zaključajte vozilo.',
    lock_vehicle: 'Zaključaj vozilo',
    once_you_have_contacted_customer_services: 'Kada ste kontaktirali korisničku podršku',
    vehicle_location: 'Lokacija vozila',
    collect_your: 'Preuzmite',
    from: 'na lokaciji'
  },
  checkout: {
    tell_us_where_you_have_parked: 'Navedite gdje ste parkirali vozilo.',
    fuel_and_milage: 'Gorivo i kilometraža',
    you_confirm_the_readings_at_the_end_of_your_hire: 'Očitanje odometra i količine goriva potvrđujete na kraju najma.',
    inspect: 'Provjera',
    we_will_as_for_four_photos_from_each_corner_of_the_vehicle_along_with_any_new_damage: 'Zatražit ćemo od vas 4 fotografije - po jednu sa svakog ugla vozila, kao i slike oštećenja koje ste pretrpjeli za vrijeme najma.',
    lock: 'Zaključavanje',
    check_you_have_left_no_belonging_then_lock_the_vehicle: 'Uvjerite se da u vozilu niste ostavili svoje stvari pa zaključajte vozilo.',
    please_tell_us_where_you_have_parked_the_vehicle: 'Navedite gdje ste parkirali vozilo.',
    once_the_vehicle_is_locked_you_will_be_unable_to_unlock_it_again: 'Kada jednom zaključate vozilo, više ga nećete moći otključati.',
    name_please_check_you_have_left_no_belongings_then_lock_the_vehicle: '{first_name}, provjerite da niste ostavili stvari, zaključajte vozilo i po potrebi vratite fizički ključ na držač ključeva.',
    lock_vehicle: 'Zaključaj vozilo',
    complete_check_in: 'Završi preuzimanje',
    inspection: 'Provjera',
    complete_vehicle_check_in: 'Završi preuzimanje vozila',
    we_are_unable_to_complete_your_vehicle_check_in: 'Ne možemo dovršiti preuzimanje vašeg vozila.',
    please_contact_customer_services: 'Obratite se našoj korisničkoj podršci.',
    once_you_have_contacted_customer_services: 'Kada ste kontaktirali korisničku podršku',
    key_in_glove_box: 'a kulcsa a kesztyűtartóban található',

    keyholder: {
      not_detected: 'Ključ nije otkriven u vlasniku ključeva',
      not_detected_please_try_again: 'Stavite svoj ključ u držač ključeva, a zatim pokušajte ponovo.',

      not_installed: 'Držač ključeva nije instaliran',
      not_installed_please_contact_customer_service: 'Držač ključeva nije instaliran, kontaktirajte službu za korisnike.',
    },
    keyring: {
      look_up_failed: 'Traženje ključa nije uspjelo',
      look_up_failed_please_contact_customer_service: 'Provjera ključa nije uspjela, kontaktirajte službu za korisnike.',
    },
    key: {
      invalid: 'Ključ nije važeći',
      invalid_please_contact_customer_service: 'Vaš ključ nije važeći, kontaktirajte službu za korisnike.',

      expired: 'Ključ je istekao',
      expired__please_contact_customer_service: 'Vaš je ključ istekao, kontaktirajte službu za korisnike.',
    }
  },
  full_insurance_no_deposit: 'Potpuno osiguranje i nije potreban depozit',
  excess: '{amount} višak',
  deposit: '{amount} depozit',
  included_daily_distance: '{distance} {unit} dnevno',
  miles: 'milja',
  kilometers: 'kilometara',
  collection_details_title: 'Pojedinosti o kolekciji',
  collection_details_not_found: 'Za ovo mjesto nisu definirani detalji zbirke',
  free_cancellation: 'Besplatno otkazivanje',
  no_deposit: 'Ne depozit',
  benefit_from: 'Korist od',
  for_only_per_day: 'Samo {price} dnevno',
  upgrade_mee: 'UpgradeMee'
}